import { Route, Routes } from "react-router-dom";
import { Routes as FleetServiceRoutes } from "./routes";
import { FleetServiceRouterCmp } from "./types";
import { ServiceSearchPage } from "../pages/ServiceSearchPage";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FleetServiceRouter: FleetServiceRouterCmp = () => {
  return (
    <>
      <Routes>
        <Route path={ServiceSearchPage.route} element={<ServiceSearchPage />} />
      </Routes>
    </>
  );
};

FleetServiceRouter.route = FleetServiceRoutes.FleetServiceRouter;

export default FleetServiceRouter;
